import { render } from "./PurchaseReturnList.vue?vue&type=template&id=3553c046&scoped=true"
import script from "./PurchaseReturnList.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnList.vue?vue&type=script&lang=js"

import "./PurchaseReturnList.vue?vue&type=style&index=0&id=3553c046&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3553c046"]])

export default __exports__